import styled from "styled-components";

export const UserDetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  overflow: scroll;
  max-height: calc(100vh - 300px);
`;

export const SelectCardContainer = styled.div`
  display: flex;
  gap: 16px;
  flex-direction: column;

  & > div > div > div > div > div:nth-child(2) {
    align-items: flex-start;
  }
`;

export const StepperContainer = styled.div`
  position: sticky;
  top: 0;
  z-index: 1;
  background: ${(props) => props.theme?.colors?.white || "#fff"};
  padding: 16px 0 8px;
`;

